<template>
  <q-page padding>
    <div style="align-items: center" class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Gestão de Catálogo</p>
      <p class="q-ml-sm text-brand-5">- e fluxo de aprovação de novos itens</p>
    </div>
    <section class="row">
      <div style="width: 15%" class="col-2 col-md-2">
        <q-select
          :options="status"
          dense
          outlined
          label="Status"
          v-model="statusValue"
          map-options
        />
      </div>

      <div style="width: 15%" class="col-2 col-md-2 q-ml-sm">
        <q-input dense outlined label="Produto" v-model="produto" />
      </div>
    </section>
    <div v-if="acompanhamentos.length != 0" class="q-mt-xl">
      <span class="text-brand-5 text-weight-bold" style="font-size: 18px"
        >Inclusões e pendências</span
      >
      <q-expansion-item
        v-for="(value, index) in acompanhamentos"
        :key="index"
        class="q-mt-md"
        header-class="bg-accent"
        expand-separator
        style="border: 1px solid black; border-radius: 5px; height: 100%"
        icon="list"
        :label="
          value?.product?.name +
          ' ' +
          nextAprover(value?.workflow_progress[0]?.data)
        "
      >
        <q-card>
          <q-card-section>
            <table style="width: 100%">
              <tr>
                <th>Código</th>
                <th>Status:</th>
                <th>Categoria:</th>
                <th>Estoque Mínimo:</th>
                <th>Estoque Máximo:</th>
                <th>Ponto de Reposição:</th>
                <th>Consumo Estimado:</th>
                <th>Part#:</th>
                <th>Fabricante:</th>
                <th>CFOP:</th>
                <th>ICMS:</th>
                <th>Preço C/ ICMS:</th>
                <th>Volume esperado:</th>
              </tr>
              <tr>
                <td>
                  {{ value.product.code }}
                </td>
                <td>{{ value.status }}</td>
                <td>
                  {{ value.product_category_code }}
                </td>
                <td>
                  {{ value.minimal_amount }}
                </td>
                <td>{{ value.max_amount }}</td>
                <td>
                  {{ value.replacement_amount }}
                </td>
                <td>
                  {{ value.consumo_estimado }}
                </td>
                <td>
                  {{ value.part_number }}
                </td>
                <td>{{ value.fabricante }}</td>
                <td>{{ value.cfop }}</td>
                <td>{{ value.icms }}</td>
                <td>R$: {{ value.price }}</td>
                <td>
                  {{ value.consumo_estimado }}
                </td>
              </tr>
            </table>
            <q-separator style="height: 2px" color="black" class="q-mt-sm" />
            <table class="q-mt-sm" style="width: 100%">
              <tr>
                <th>CRIADOR</th>
                <th>SOLICITANTE</th>
                <th>LIDER GERENTE</th>
                <th>HSE</th>
                <th>STORE ROOM</th>
                <th>COMPRAS</th>
              </tr>
              <tr>
                <td>
                  {{
                    value.workflow_progress[0] &&
                    value.workflow_progress[0].data &&
                    value.workflow_progress[0].data.criador
                      ? value.workflow_progress[0].data.criador.user.name
                      : ""
                  }}
                </td>
                <td>
                  {{
                    value.workflow_progress[0] &&
                    value.workflow_progress[0].data &&
                    value.workflow_progress[0].data.solicitante
                      ? value.workflow_progress[0].data.solicitante.user.name
                      : ""
                  }}
                </td>
                <td>
                  {{
                    value.workflow_progress[0] &&
                    value.workflow_progress[0].data &&
                    value.workflow_progress[0].data.lider_gerente_linha
                      ? value.workflow_progress[0].data.lider_gerente_linha.user
                          .name
                      : ""
                  }}
                </td>
                <td>
                  {{
                    value.workflow_progress[0] &&
                    value.workflow_progress[0].data &&
                    value.workflow_progress[0].data.hse
                      ? value.workflow_progress[0].data.hse.user.name
                      : ""
                  }}
                </td>
                <td>
                  {{
                    value.workflow_progress[0] &&
                    value.workflow_progress[0].data &&
                    value.workflow_progress[0].data.store_room
                      ? value.workflow_progress[0].data.store_room.user.name
                      : ""
                  }}
                </td>
                <td>
                  {{
                    value.workflow_progress[0] &&
                    value.workflow_progress[0].data &&
                    value.workflow_progress[0].data.compras
                      ? value.workflow_progress[0].data.compras.user.name
                      : ""
                  }}
                </td>
              </tr>
              <tr
                style="height: 60px"
                v-if="
                  value?.status == 'Aguardando' || value?.status == 'Reprovado'
                "
              >
                <td
                  :style="{
                    backgroundColor: getColorType(
                      value.workflow_progress[0]?.data?.criador?.status
                    ),
                  }"
                  style="text-align: center; min-width: 150px"
                >
                  <div
                    v-if="value?.status == 'Aguardando'"
                    class="row justify-center"
                  >
                    <q-btn
                      v-if="
                        value.workflow_progress[0]?.data?.criador?.status !=
                          'Aprovado' &&
                        value.workflow_progress[0]?.data?.criador?.user?.id ==
                          $store.state.autenticacao.idBase
                      "
                      color="positive"
                      round
                      icon="check"
                      class="q-ml-sm"
                      @click="aprovar(value.contract_id, value.product_id)"
                    />

                    <q-btn
                      v-if="
                        value.workflow_progress[0]?.data?.criador?.status !=
                          'Aprovado' &&
                        value.workflow_progress[0]?.data?.criador?.user.id ==
                          $store.state.autenticacao.idBase
                      "
                      color="negative"
                      round
                      icon="close"
                      class="q-ml-sm"
                      @click="reprovar(value.contract_id, value.product_id)"
                    />
                  </div>
                  <div class="column">
                    <span
                      v-if="
                        value.workflow_progress[0]?.data?.criador?.status ==
                          'Aprovado' ||
                        value.workflow_progress[0]?.data?.criador?.status ==
                          'Reprovado'
                      "
                      >{{
                        value.workflow_progress[0].data.criador.date
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}</span
                    >

                    <span
                      v-if="
                        value.workflow_progress[0]?.data?.criador?.status ==
                          'Aprovado' ||
                        value.workflow_progress[0]?.data?.criador?.status ==
                          'Reprovado'
                      "
                      >{{
                        value.workflow_progress[0].data.criador.date.split(
                          " "
                        )[1]
                      }}</span
                    >
                  </div>
                </td>
                <td
                  :style="{
                    backgroundColor: getColorType(
                      value.workflow_progress[0]?.data?.solicitante?.status
                    ),
                  }"
                  style="text-align: center; min-width: 150px"
                >
                  <div
                    v-if="value?.status == 'Aguardando'"
                    class="row justify-center"
                  >
                    <q-btn
                      v-if="
                        value.workflow_progress[0].data?.solicitante?.status !=
                          'Aprovado' &&
                        value.workflow_progress[0].data?.solicitante?.user.id ==
                          $store.state.autenticacao.idBase &&
                        value.workflow_progress[0].data?.criador?.status ==
                          'Aprovado'
                      "
                      color="positive"
                      round
                      icon="check"
                      class="q-ml-sm"
                      @click="aprovar(value.contract_id, value.product_id)"
                    />

                    <q-btn
                      v-if="
                        value.workflow_progress[0].data?.solicitante?.status !=
                          'Aprovado' &&
                        value.workflow_progress[0].data?.solicitante?.user
                          ?.id == $store.state.autenticacao.idBase &&
                        value.workflow_progress[0].data?.criador?.status ==
                          'Aprovado'
                      "
                      color="negative"
                      round
                      icon="close"
                      class="q-ml-sm"
                      @click="reprovar(value.contract_id, value.product_id)"
                    />
                  </div>

                  <div class="column">
                    <span
                      v-if="
                        value.workflow_progress[0].data?.solicitante?.status ==
                          'Aprovado' ||
                        value.workflow_progress[0].data?.solicitante?.status ==
                          'Reprovado'
                      "
                      >{{
                        value.workflow_progress[0].data?.solicitante?.date
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}</span
                    >

                    <span
                      v-if="
                        value.workflow_progress[0].data?.solicitante?.status ==
                          'Aprovado' ||
                        value.workflow_progress[0].data?.solicitante?.status ==
                          'Reprovado'
                      "
                      >{{
                        value.workflow_progress[0].data?.solicitante?.date.split(
                          " "
                        )[1]
                      }}</span
                    >
                  </div>
                </td>
                <td
                  :style="{
                    backgroundColor: getColorType(
                      value.workflow_progress[0]?.data?.lider_gerente_linha
                        ?.status
                    ),
                  }"
                  style="text-align: center; min-width: 150px"
                >
                  <div
                    v-if="value?.status == 'Aguardando'"
                    class="row justify-center"
                  >
                    <q-btn
                      v-if="
                        value.workflow_progress[0]?.data?.lider_gerente_linha
                          ?.status != 'Aprovado' &&
                        value.workflow_progress[0]?.data?.lider_gerente_linha
                          ?.user.id == $store.state.autenticacao.idBase &&
                        value.workflow_progress[0]?.data?.solicitante?.status ==
                          'Aprovado'
                      "
                      color="positive"
                      round
                      icon="check"
                      class="q-ml-sm"
                      @click="aprovar(value.contract_id, value.product_id)"
                    />

                    <q-btn
                      v-if="
                        value.workflow_progress[0]?.data?.lider_gerente_linha
                          ?.status != 'Aprovado' &&
                        value.workflow_progress[0]?.data?.lider_gerente_linha
                          ?.user.id == $store.state.autenticacao.idBase &&
                        value.workflow_progress[0]?.data?.solicitante?.status ==
                          'Aprovado'
                      "
                      color="negative"
                      round
                      icon="close"
                      class="q-ml-sm"
                      @click="reprovar(value.contract_id, value.product_id)"
                    />
                  </div>

                  <div class="column">
                    <span
                      v-if="
                        value.workflow_progress[0]?.data?.lider_gerente_linha
                          ?.status == 'Aprovado' ||
                        value.workflow_progress[0]?.data?.lider_gerente_linha
                          ?.status == 'Reprovado'
                      "
                      >{{
                        value.workflow_progress[0].data.lider_gerente_linha.date
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}</span
                    >

                    <span
                      v-if="
                        value.workflow_progress[0]?.data.lider_gerente_linha
                          ?.status == 'Aprovado'
                      "
                      >{{
                        value.workflow_progress[0].data.lider_gerente_linha.date.split(
                          " "
                        )[1]
                      }}</span
                    >
                  </div>
                </td>
                <td
                  :style="{
                    backgroundColor: getColorType(
                      value.workflow_progress[0]?.data?.hse?.status
                    ),
                  }"
                  style="text-align: center; min-width: 150px"
                >
                  <div
                    v-if="value?.status == 'Aguardando'"
                    class="row justify-center"
                  >
                    <q-btn
                      v-if="
                        value.workflow_progress[0]?.data?.hse?.status !=
                          'Aprovado' &&
                        value.workflow_progress[0]?.data?.hse?.user?.id ==
                          $store.state.autenticacao.idBase &&
                        value.workflow_progress[0]?.data?.lider_gerente_linha
                          ?.status == 'Aprovado'
                      "
                      color="positive"
                      round
                      icon="check"
                      class="q-ml-sm"
                      @click="aprovar(value.contract_id, value.product_id)"
                    />

                    <q-btn
                      v-if="
                        value.workflow_progress[0]?.data?.hse?.status !=
                          'Aprovado' &&
                        value.workflow_progress[0]?.data?.hse?.user?.id ==
                          $store.state.autenticacao.idBase &&
                        value.workflow_progress[0]?.data?.lider_gerente_linha
                          ?.status == 'Aprovado'
                      "
                      color="negative"
                      round
                      icon="close"
                      class="q-ml-sm"
                      @click="reprovar(value.contract_id, value.product_id)"
                    />
                  </div>

                  <div class="column">
                    <span
                      v-if="
                        value.workflow_progress[0]?.data?.hse?.status ==
                          'Aprovado' ||
                        value.workflow_progress[0]?.data?.hse?.status ==
                          'Reprovado'
                      "
                      >{{
                        value.workflow_progress[0].data.hse.date
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}</span
                    >

                    <span
                      v-if="
                        value.workflow_progress[0]?.data?.hse?.status ==
                          'Aprovado' ||
                        value.workflow_progress[0]?.data?.hse?.status ==
                          'Reprovado'
                      "
                      >{{
                        value.workflow_progress[0].data.hse.date.split(" ")[1]
                      }}</span
                    >
                  </div>
                </td>
                <td
                  :style="{
                    backgroundColor: getColorType(
                      value.workflow_progress[0]?.data?.store_room?.status
                    ),
                  }"
                  style="text-align: center; min-width: 150px"
                >
                  <div
                    v-if="value?.status == 'Aguardando'"
                    class="row justify-center"
                  >
                    <q-btn
                      v-if="
                        value.workflow_progress[0]?.data?.store_room?.status !=
                          'Aprovado' &&
                        value.workflow_progress[0]?.data?.store_room?.user
                          ?.id == $store.state.autenticacao.idBase &&
                        value.workflow_progress[0]?.data?.hse?.status ==
                          'Aprovado'
                      "
                      color="positive"
                      round
                      icon="check"
                      class="q-ml-sm"
                      @click="aprovar(value.contract_id, value.product_id)"
                    />

                    <q-btn
                      v-if="
                        value.workflow_progress[0]?.data?.store_room?.status !=
                          'Aprovado' &&
                        value.workflow_progress[0]?.data?.store_room?.user
                          ?.id == $store.state.autenticacao.idBase &&
                        value.workflow_progress[0]?.data?.hse?.status ==
                          'Aprovado'
                      "
                      color="negative"
                      round
                      icon="close"
                      class="q-ml-sm"
                      @click="reprovar(value.contract_id, value.product_id)"
                    />
                  </div>

                  <div class="column">
                    <span
                      v-if="
                        value.workflow_progress[0]?.data?.store_room?.status ==
                          'Aprovado' ||
                        value.workflow_progress[0]?.data?.store_room?.status ==
                          'Reprovado'
                      "
                      >{{
                        value.workflow_progress[0].data.store_room.date
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}</span
                    >

                    <span
                      v-if="
                        value.workflow_progress[0]?.data?.store_room?.status ==
                          'Aprovado' ||
                        value.workflow_progress[0]?.data?.store_room?.status ==
                          'Reprovado'
                      "
                      >{{
                        value.workflow_progress[0].data.store_room.date.split(
                          " "
                        )[1]
                      }}</span
                    >
                  </div>
                </td>
                <td
                  :style="{
                    backgroundColor: getColorType(
                      value.workflow_progress[0]?.data?.compras?.status
                    ),
                  }"
                  style="text-align: center; min-width: 150px"
                >
                  <div
                    v-if="value?.status == 'Aguardando'"
                    class="row justify-center"
                  >
                    <q-btn
                      v-if="
                        value.workflow_progress[0]?.data?.compras?.status !=
                          'Aprovado' &&
                        value.workflow_progress[0]?.data?.compras?.user?.id ==
                          $store.state.autenticacao.idBase &&
                        value.workflow_progress[0]?.data?.store_room?.status ==
                          'Aprovado'
                      "
                      color="positive"
                      round
                      icon="check"
                      class="q-ml-sm"
                      @click="aprovar(value.contract_id, value.product_id)"
                    />

                    <q-btn
                      v-if="
                        value.workflow_progress[0]?.data?.compras?.status !=
                          'Aprovado' &&
                        value.workflow_progress[0]?.data?.compras?.user?.id ==
                          $store.state.autenticacao.idBase &&
                        value.workflow_progress[0]?.data?.store_room?.status ==
                          'Aprovado'
                      "
                      color="negative"
                      round
                      icon="close"
                      class="q-ml-sm"
                      @click="reprovar(value.contract_id, value.product_id)"
                    />
                  </div>

                  <div class="column">
                    <span
                      v-if="
                        value.workflow_progress[0]?.data?.compras?.status ==
                          'Aprovado' ||
                        value.workflow_progress[0]?.data?.compras?.status ==
                          'Reprovado'
                      "
                      >{{
                        value.workflow_progress[0].data.compras.date
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}</span
                    >

                    <span
                      v-if="
                        value.workflow_progress[0]?.data?.compras?.status ==
                          'Aprovado' ||
                        value.workflow_progress[0]?.data?.compras?.status ==
                          'Reprovado'
                      "
                      >{{
                        value.workflow_progress[0]?.data?.compras?.date.split(
                          " "
                        )[1]
                      }}</span
                    >
                  </div>
                </td>
              </tr>
              <tr v-if="value?.status == 'Aprovado'">
                <td style="text-align: center; background-color: #58c16d">
                  <div class="column">
                    <span>{{
                      value.workflow_progress[0] &&
                      value.workflow_progress[0].data &&
                      value.workflow_progress[0].data.criador
                        ? value.workflow_progress[0].data.criador.date
                            .split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                        : ""
                    }}</span>
                    <span>
                      {{
                        value.workflow_progress[0] &&
                        value.workflow_progress[0].data &&
                        value.workflow_progress[0].data.criador
                          ? value.workflow_progress[0].data.criador.date.split(
                              " "
                            )[1]
                          : ""
                      }}</span
                    >
                  </div>
                </td>
                <td style="text-align: center; background-color: #58c16d">
                  <div class="column">
                    <span>{{
                      value.workflow_progress[0] &&
                      value.workflow_progress[0].data &&
                      value.workflow_progress[0].data.solicitante
                        ? value.workflow_progress[0].data.solicitante.date
                            .split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                        : ""
                    }}</span>
                    <span>
                      {{
                        value.workflow_progress[0] &&
                        value.workflow_progress[0].data &&
                        value.workflow_progress[0].data.solicitante
                          ? value.workflow_progress[0].data.solicitante.date.split(
                              " "
                            )[1]
                          : ""
                      }}</span
                    >
                  </div>
                </td>
                <td style="text-align: center; background-color: #58c16d">
                  <div class="column">
                    <span>{{
                      value.workflow_progress[0] &&
                      value.workflow_progress[0].data &&
                      value.workflow_progress[0].data.lider_gerente_linha
                        ? value.workflow_progress[0].data.lider_gerente_linha.date
                            .split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                        : ""
                    }}</span>
                    <span>
                      {{
                        value.workflow_progress[0] &&
                        value.workflow_progress[0].data &&
                        value.workflow_progress[0].data.lider_gerente_linha
                          ? value.workflow_progress[0].data.lider_gerente_linha.date.split(
                              " "
                            )[1]
                          : ""
                      }}</span
                    >
                  </div>
                </td>
                <td style="text-align: center; background-color: #58c16d">
                  <div class="column">
                    <span>
                      {{
                        value.workflow_progress[0] &&
                        value.workflow_progress[0].data &&
                        value.workflow_progress[0].data.hse
                          ? value.workflow_progress[0].data.hse.date
                              .split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("/")
                          : ""
                      }}</span
                    >
                    <span>{{
                      value.workflow_progress[0] &&
                      value.workflow_progress[0].data &&
                      value.workflow_progress[0].data.hse
                        ? value.workflow_progress[0].data.hse.date.split(" ")[1]
                        : ""
                    }}</span>
                  </div>
                </td>
                <td style="text-align: center; background-color: #58c16d">
                  <div class="column">
                    <span>
                      {{
                        value.workflow_progress[0] &&
                        value.workflow_progress[0].data &&
                        value.workflow_progress[0].data.store_room
                          ? value.workflow_progress[0].data.store_room.date
                              .split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("/")
                          : ""
                      }}</span
                    >
                    <span>
                      {{
                        value.workflow_progress[0] &&
                        value.workflow_progress[0].data &&
                        value.workflow_progress[0].data.store_room
                          ? value.workflow_progress[0].data.store_room.date.split(
                              " "
                            )[1]
                          : ""
                      }}</span
                    >
                  </div>
                </td>
                <td style="text-align: center; background-color: #58c16d">
                  <div class="column">
                    <span>{{
                      value.workflow_progress[0] &&
                      value.workflow_progress[0].data &&
                      value.workflow_progress[0].data.compras
                        ? value.workflow_progress[0].data.compras.date
                            .split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                        : ""
                    }}</span>
                    <span>
                      {{
                        value.workflow_progress[0] &&
                        value.workflow_progress[0].data &&
                        value.workflow_progress[0].data.compras
                          ? value.workflow_progress[0].data.compras.date.split(
                              " "
                            )[1]
                          : ""
                      }}</span
                    >
                  </div>
                </td>
              </tr>
            </table>

            <q-input
              class="q-mt-sm"
              type="textarea"
              dense
              outlined
              label="Digira aqui uma mensagem para aprovar ou reprovar o estágio"
              v-model="descricao"
            />
          </q-card-section>
        </q-card>
      </q-expansion-item>
    </div>
  </q-page>
</template>

<script>
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
export default {
  setup() {
    const store = useStore();

    const quasar = useQuasar();
    const route = useRoute();
    const statusValue = ref("Aguardando");
    const acompanhamentos = ref([]);
    const descricao = ref("");
    const disable = ref(true);
    const produto = ref("");
    const id = route.params.id;
    const filtros = ref({
      dataInicial: "",
      dataFinal: new Date()
        .toLocaleString("pt-br")
        .split(" ")[0]
        .replace(",", " "),
      solicitante: "",
    });

    const acompanhar = async () => {
      try {
        let response = await store.dispatch("wf/getAcompanhamento", {
          id: id,
          status: statusValue.value,
          produto: produto.value,
        });
        acompanhamentos.value = response.data.results.data;
        disable.value = false;
      } catch (error) {
        acompanhamentos.value = [];
        quasar.notify({
          message: `Erro a o procurar dados de ${statusValue.value}`,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(acompanhar);

    const aprovar = async (contract_id, product_id) => {
      try {
        await store.dispatch("wf/aprovar", {
          contract_id,
          products: [{ product_id: product_id }],
        });

        quasar.notify({
          message: "Aprovador com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        setTimeout(() => {
          acompanhar();
        }, 1500);
      } catch (error) {
        quasar.notify({
          message: "Erro a o aprovar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getColorType = (value) => {
      switch (value) {
        case "Aguardando":
          return null;

        case "Aprovado":
          return "#58C16D";

        case "Reprovado":
          return "#E23431";

        default:
      }
    };

    const reprovar = async (contract_id, product_id) => {
      try {
        await store.dispatch("wf/reprovar", {
          contract_id,
          products: [{ product_id: product_id }],
        });

        setTimeout(() => {
          acompanhar();
        }, 2000);
        location.reload();
      } catch (error) {
        quasar.notify({
          message: "Erro a o aprovar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch([() => statusValue.value, () => produto.value], () => {
      acompanhar();
    });

    const nextAprover = (value) => {
      if (statusValue.value != "Aguardando") {
        return "";
      }

      if (value?.criador?.status != "Aprovado") {
        return `| Aprovador da vez: ${value?.criador?.user?.name}`;
      } else if (value?.solicitante?.status != "Aprovado") {
        return `| Aprovador da vez: ${value?.solicitante?.user?.name}`;
      } else if (value?.lider_gerente_linha?.status != "Aprovado") {
        return `| Aprovador da vez: ${value?.lider_gerente_linha?.user?.name}`;
      } else if (value?.hse?.status != "Aprovado") {
        return `| Aprovador da vez: ${value?.hse?.user?.name}`;
      } else if (value?.store_room?.status != "Aprovado") {
        return `| Aprovador da vez: ${value?.store_room?.user?.name}`;
      } else if (value?.compras?.status != "Aprovado") {
        return `| Aprovador da vez: ${value?.compras?.user?.name}`;
      }
    };

    return {
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,

      disable,

      acompanhar,
      status: ["Aprovado", "Aguardando", "Cancelado", "Reprovado"],
      statusValue,
      acompanhamentos,
      descricao,
      aprovar,
      reprovar,
      getColorType,
      produto,
      nextAprover,
    };
  },
};
</script>

<style scoped>
td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>
